module.exports = __webpack_public_path__ + "img/vast_team_interface.4ace2b92.png";